class BannerOrderNowBtn extends HTMLElement {
  constructor(){
    super();
    this.productSection = document.querySelector('.giftSection')
    this.querySelector('a').addEventListener('click', this.handleJump.bind(this))
  }
  handleJump(e){
    e.preventDefault();
    if(this.productSection){
      this.productSection.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
customElements.define('banner-order-now-btn', BannerOrderNowBtn)

class OrderForm extends HTMLElement{
  constructor(){
    super();
    this.querySelector('form').addEventListener('submit', this.handleSubmit.bind(this));
  }
  async handleSubmit(e){
    e.preventDefault();
    let formData = new FormData(this.querySelector('form'))
     var formValues = {};

    let body = ``;
  
    for (var pair of formData.entries()) {
      if(pair[1] != '' || pair[0] != 'product-description' || pair[0] != 'contact[terms-and-conditions]'){
        let name = pair[0].replace('contact[', '')
        formValues[name.replace(']', '')] = pair[1]
      }
      // if(pair[1] && pair[1] != '' || pair[0] != 'termsTxt'){
      //   formValues[pair[0]] = pair[1];
      //   if(pair[1] != 'uploadDoc'){
      //      body += `<p>${pair[0]} : ${pair[1]}</p>` 
      //   }
      // }
    }

    // console.log(formValues);
    // return ;
    delete formValues['terms-and-conditions']
    if(formValues.note == ''){
      delete formValues['note']
    }
    delete formValues['product-description']
    let obj = {
      "first-name": "First Name",
      "last-name": "Last Name",
      "email": "Email",
      // "address" :"Address",
      "company": "Company",
      "delivery-timeframe": "Delivery Timeframe",
      "phone": "Phone",
      // "personalized-branding": "Personalized Branding",
      "qty": "Qty",
      // "shipping-address": "Shipping Addresses",
      // "gift-discount": "Gift Discount",
      // "branding-option": "Branding Option",
      // "cart-data": "Cart",
      "additional-note": "Note"
    }

    // let cart = '';

    // let cartItems = this.querySelectorAll('.giftCart .cartItem') ? this.querySelectorAll('.giftCart .cartItem') : [];
    // if(cartItems.length == 0){
    //   // return ;
    //   cart += "Cart is empty"
    // }else{
    //   cart += "Total Items: " +cartItems.length +"\n-----------------------------------" + "\n";
    // }
    // cartItems.forEach(item => {
    //   cart += (`Product ID: ${item.getAttribute('data-cart-id')}` + "\n")
    //   cart += (`Product Name: ${item.querySelector('[data-product-name]').value}` + "\n")
    //   if(item.querySelector('.discount')){
    //     let temp = document.createElement('div');
    //     temp.innerHTML = item.querySelector('.discount').innerHTML;
    //     cart += ("Discount: " +temp.innerText);
    //   }
    //   cart += (`-----------------------------------` + "\n")
    // })
    // formValues['cart-data'] = cart;
    // let obj = {
    //   "first-name": "First Name",
    //   "last-name": "Last Name",
    //   "email": "Email",
    //   "address" :"Address",
    //   "company": "Company",
    //   "delivery-timeframe": "Delivery Timeframe",
    //   "personalized-branding": "Personalized Branding",
    //   "product-id": "Product ID",
    //   "product-name" : "Product Name",
    //   "qty": "Qty",
    //   "shipping-address": "Shipping Addresses",
    //   "gift-discount": "Gift Discount",
    //   "branding-option": "Branding Option",
    //   "cart": "Cart"
    // }
    delete obj['product-id']
    delete obj['product-name']
    delete obj['data-product-id']
    delete formValues['product-id']
    delete formValues['product-name']
    delete formValues['data-product-id']

    delete formValues['uploadDoc']
    // if(formValues['shipping-address'] == 'one'){
    //   delete formValues['uploadDoc']
    // }else{
    //   // formValues['address'] = formValues['uploadDoc'];
    //   formValues['file'] = formValues['uploadDoc'];
    //   obj['file'] = 'Address'
    //   delete formValues['uploadDoc']
    //   delete formValues['address']
    // }

    // if(formValues['personalized-branding'] == 'no'){
    //   delete formData['branding-option'];
    // }
    
    let updateForm = new FormData();
    for(const key in formValues){
      updateForm.append(key, formValues[key])
    }
    updateForm.append('_keyLabel', JSON.stringify(obj))
    updateForm.append('locale', 'en');
    updateForm.append('time_zone', Intl.DateTimeFormat().resolvedOptions().timeZone);

    updateForm.append('customer[id]', '');
    updateForm.append('customer[email]', '');
    updateForm.append('customer[name]', '');
    updateForm.append('page[title]', 'Gift Page');
    updateForm.append('page[href]', location.href);
    for (var pair of updateForm.entries())
    {
      console.log(pair[0]+ ', '+ pair[1]); 
    }
    this.querySelector('.formSubmitBtn input').setAttribute('disabled', true);
    this.querySelector('.formSubmitBtn input').value = 'Please wait...';
    let res = await fetch('https://app.powerfulform.com//api/front/form/5480/send', {
      method: 'POST',
      body: updateForm
    });
    let data = await res.json();
    if(data.success == "false"){
      let error = ``;
      for(const key in data.errors){
        error += `<li>${key}: ${data.errors[key][0]}</li>`
      }
      this.querySelector('.note.form-error ul').innerHTML = error;
      this.querySelector('.note.form-error').style.display = 'block';
      this.querySelector('.note.form-success').style.display = 'none'
      this.querySelector('.note.form-error').scrollIntoView({
        behavior: "smooth"
      })
      this.querySelector('.formSubmitBtn input').removeAttribute('disabled', true);
      this.querySelector('.formSubmitBtn input').value = this.querySelector('.formSubmitBtn input').getAttribute('data-default-value'); 
      return ;
    }
    let success = document.querySelector('.form-success');
    success.style.display = 'block';
    success.scrollIntoView({
      behavior: 'smooth'
    })
    this.querySelector('.formSubmitBtn input').removeAttribute('disabled', true);
    this.querySelector('.formSubmitBtn input').value = this.querySelector('.formSubmitBtn input').getAttribute('data-default-value'); 
    console.log(data);
    console.log(this.querySelector('.formSubmitBtn input').getAttribute('data-default-value'));
    // cartItems.forEach(item => item.remove());
    // this.querySelector('.emptyCart').style.display = 'block';
    // this.querySelector('.emptyCart input').setAttribute('required', true);
    // this.querySelector('selected-product .itemImgBox img').src = 'https://cdn.shopify.com/s/files/1/0637/7989/7568/t/26/assets/cartIcon.png?v=161721343689010578561684909070'
    // this.querySelector('selected-product .itemTxtBox h3').innerText = this.defaultBucket;
    // this.querySelector('selected-product .itemTxtBox p').innerHTML = this.defaultSubBucket;
    this.querySelector('.note.form-error').style.display = 'none';
    // this.handleSelectSingleAddress();
    // this.querySelector('.brandingOption div').style.display = 'none';
    // this.querySelector('.brandingOption div select').removeAttribute('required');
    // this.querySelector('.brandingOption div select').value = '';
    // this.querySelector('.itemTxtBox ul').innerHTML = '';
    this.querySelector('form').reset();
    return ;


  //   let readFile = await this.readFileAsync(formValues.uploadDoc)
  // console.log(readFile)
    
    


    // let res = await fetch('https://api.sendgrid.com/v3/mail/send', {
    //   method: 'POST',
    //   headers: {
    //     Authorization: `Bearer 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`,
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     from: 'hammad.asad@nextscrum.dev',
    //     to: 'hammad.asad.nextscrum@gmail.com',
    //     subject: 'Test Email',
    //     content: [
    //       {
    //         type: "text/html",
    //         value: body
    //       }
    //     ]
    //   })
    // })
        //     attachments: [
        //   {
        //     type:formValues.uploadDoc.type,
        //     content: readFile,
        //     filename: "test.png"
        //   }
        // ]
    // console.log(formValues);
    // console.log(formData.entries())
  }
  handleChooseFile(e){
    let file = e.target.files[0];
    const fileSizeInMB = file.size / (1024 * 1024); // Convert file size to MB

    if (fileSizeInMB > 5) {
      alert("File size exceeds the limit of 5 MB.");
       this.querySelector('.fileUploaderItem input').value = ""; // Clear the file input
      return ;
    }
    this.querySelector('.attachedFile').style.display = 'inline-block';
    this.querySelector('.attachedFile p').innerHTML = file.name;
    console.log(e.target.files);
  }
  handleClearFile(e){
    e.preventDefault();
    this.querySelector('.attachedFile').style.display = 'none';
    this.querySelector('.fileUploaderItem input').value = ""; // Clear the file input
  }
  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = function (e) {
        const fileContent = e.target.result;
        resolve(fileContent);
      };
  
      reader.onerror = function (e) {
        reject(e.target.error);
      };
  
      reader.readAsText(file);
    });
  }
  handleChangeBrandingOption(e){
    let value = e.target.value;
    if(value == 'yes'){
      this.querySelector('.brandingOption div').style.display = 'block';
      this.querySelector('.brandingOption div select').setAttribute('required', true);
    }else{
      this.querySelector('.brandingOption div').style.display = 'none';
      this.querySelector('.brandingOption div select').removeAttribute('required');
    }
  }
}
customElements.define('order-form', OrderForm)

class SelectedProduct extends HTMLElement {
  constructor(){
    super();
    this.querySelector('a').addEventListener('click', this.handlePreviewProduct.bind(this))
    this.productSection = document.querySelector('.giftSection')
    this.querySelector('button.unselectProductBtn').addEventListener('click', this.handleRemoveCartItem.bind(this));
  }
  handlePreviewProduct(e){
    e.preventDefault();
    let productID = this.querySelector('[data-product-name]').value;
    if(!productID || productID == ''){
      this.productSection.scrollIntoView({
        behavior: 'smooth'
      })
    }else{
      window.open(this.querySelector('a').href, "_blank")
      // let a = document.createElement('a');
      // a.href = this.querySelector('a').href;
      // a.getAttribute('target', '_blank');
      // a.click();
    }
  }
  handleRemoveCartItem(e){
    e.preventDefault();
    // let cart = sessionStorage.getItem('gift_cart') ? JSON.parse(sessionStorage.getItem('gift_cart')) : [];
    // // cart.push(item);
    // cart = cart.filter(item => item.id != this.closest('li').getAttribute('data-cart-id'));
    // sessionStorage.setItem('gift_cart', JSON.stringify(cart))
    if(this.closest('ul').querySelectorAll('.cartItem').length == 1){
      this.closest('ul').querySelector('.emptyCart').style.display = 'block';

      this.closest('form').querySelector('label[for="note"] span').innerText = "*";
      this.closest('form').querySelector('#note').setAttribute('required', true);
      this.closest('form').querySelector('#note').setAttribute('aria-required', true);
      this.closest('form').querySelector('.note-msg').style.display = 'block';
      // this.closest('ul').querySelector('.emptyCart .hideFieldBox').setAttribute('required', true);
    }
    this.closest('li').remove();
  }
}
customElements.define('selected-product', SelectedProduct)

class AddAddtionalAddress extends HTMLElement {
  constructor(){
    super();
    this.querySelector('button').addEventListener('click', this.handleAddAddressLine.bind(this))
    this.multiAdressWraper = this.closest('.multipleAddress');
  }
  handleAddAddressLine(e){
    e.preventDefault();
    let html = `<div class="addressFieldRow">
      <div class="addressFieldBox">
          <div class="formFieldBox">
              <label for="address">Your address <span>1</span></label>
              <input type="text" name="address" id="address">
          </div>
      </div>
      <div class="addressAddBtnBox">
          <remove-addtional-address>
            <button type="button">
              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;}</style></defs><title/><g data-name="Layer 2" id="Layer_2"><path d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z"/><path d="M11.76,21.24a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41l8.49-8.49A1,1,0,0,1,21,12.46L12.46,21A1,1,0,0,1,11.76,21.24Z"/><path d="M20.24,21.24a1,1,0,0,1-.7-.29l-8.49-8.49a1,1,0,0,1,1.41-1.41L21,19.54A1,1,0,0,1,21,21,1,1,0,0,1,20.24,21.24Z"/></g><g id="frame"><rect class="cls-1"/></g></svg>
              <span>Delete Address</span>
            </button>
          </remove-addtional-address>
      </div>
    </div>`;
    this.multiAdressWraper.innerHTML = this.multiAdressWraper.innerHTML + html;
    this.updateSerial()
  }
  updateSerial(){
    this.multiAdressWraper.querySelectorAll('.formFieldBox span').forEach((item, index)=>{
      item.innerText = index + 1
    })
    this.multiAdressWraper.querySelectorAll('input').forEach((item, index)=>{
      item.setAttribute('name', `contact[address-${index+1}]`)
    })
  }
}

customElements.define('add-addtional-address', AddAddtionalAddress)


class DeleteAddtionalAddress extends HTMLElement {
  constructor(){
    super();
    this.querySelector('button').addEventListener('click', this.handleRemoveAddressLine.bind(this))
    this.multiAdressWraper = this.closest('.multipleAddress');
  }
  handleRemoveAddressLine(e){
    e.preventDefault();
    let address = this.closest('.addressFieldRow');
    address.remove();
    this.updateSerial();
  }
  updateSerial(){
    this.multiAdressWraper.querySelectorAll('.formFieldBox span').forEach((item, index)=>{
      item.innerText = index + 1
    })
    this.multiAdressWraper.querySelectorAll('input').forEach((item, index)=>{
      item.setAttribute('name', `contact[address-${index+1}]`)
    })
  }
}
// customElements.define('remove-addtional-address', DeleteAddtionalAddress)


(function(){
  let buttons = document.querySelectorAll('.two__way-gift a[href^="#"]');
  buttons.forEach(btn => {
    btn.addEventListener('click', (e)=>{
      e.preventDefault();
      let id = e.currentTarget.href.split('#')
      var targetElement = document.querySelector(`#${id[1]}`);
      if(targetElement){
        if(window.innerWidth <= 989){  
          var headerHeight = document.querySelector('header').offsetHeight;
          if(targetElement){
            window.scrollTo({
                top: targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight,
                behavior: 'smooth'
            });
          }
        }else{
          window.scrollTo({
                top: targetElement.getBoundingClientRect().top + window.pageYOffset,
                behavior: 'smooth'
            });
        }
      }
    })
  })
})();



